export default __webpack_public_path__ + "static/media/ball1.c5a17ab8.png";